import auth from "../../middlewares/auth";
export const settingsAreaRoute = [
  {
    path: '/settings/area',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/area/AreaList'),
    name: 'settings_area',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/area/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/area/AreaForm'),
    name: 'settings_area_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/area/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/area/AreaForm'),
    name: 'settings_area_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];